import Contributors from './contributors';

export default Contributors;
